import React, { useState, useEffect } from 'react';
import { getCookie, shouldLogUsage } from '../../utils/helpers';
import { logReportView } from '../../utils/api_dashboard';

const ReportViewer = ({ report, navbarVisible = true }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [reportUrl, setReportUrl] = useState('');

    

    useEffect(() => {
        setLoading(true);
        setError(null);

        if (report && report.uriPath) {
            try {
            // Rely on domain-scoped cookie for auth; do not append token to URL
            var url = new URL(report.uriPath);

            //////////////////////////////////////////////
            // Handle default TV for Focus View report //
            ////////////////////////////////////////////

            // if reportId is 6 (Focus View)
            if (report.reportId === 6) {

                // get the default TV from the user profile in local storage
                const t_user = localStorage.getItem('user');
                let defaultTV = -1;
                if (t_user) {
                    try {
                        const userData = JSON.parse(t_user);
                        defaultTV = userData.defaultTV || -1;
                    } catch (parseError) {
                        console.error('Error parsing user data from localStorage:', parseError);
                    }
                }

                // set the default TV to a string
                defaultTV = defaultTV.toString();

                // append to the URL
                url.searchParams.append('id', defaultTV);

                // append landing=true
                url.searchParams.append('landing', 'true');
            }


            /////////////////////////////////////////////////////
            // Handle parameters for the Booking Trend Report //
            ///////////////////////////////////////////////////

            // if the report is the booking trend report (58)
            if (report.reportId === 58) {

                // get query params from the url
                const queryParams = new URLSearchParams(window.location.search);

                // if we have `filter_parki_id` as a parameter
                if (queryParams.has('filter_parki_id')) {

                    // get the value
                    const parkiId = queryParams.get('filter_parki_id');

                    // append to the URL
                    url.searchParams.append('filter_parki_id', parkiId);
                }

                // if we have `filter_category_type` as a parameter
                if (queryParams.has('filter_category_type')) {

                    // get the value
                    const categoryType = queryParams.get('filter_category_type');

                    // append to the URL
                    url.searchParams.append('filter_category_type', categoryType);
                }
            }

            // set the report URL state
            setReportUrl(url.toString());

            if (shouldLogUsage()) {
                const savedReport = localStorage.getItem('selectedReport');
                if (savedReport) {
                try {
                    const reportData = JSON.parse(savedReport);
                    logReportView({
                    reportName: reportData.reportName,
                    reportId: reportData.reportId
                    });
                } catch (parseError) {
                    console.error('Error parsing saved report data:', parseError);
                }
                }
            }
            } catch (err) {
            console.error('Error building report URL:', err);
            setReportUrl(report.uriPath);
            }
        }
    }, [report]);

    const handleIframeLoad = () => {
        setLoading(false);
    };

    const handleIframeError = () => {
        setLoading(false);
        setError(`Failed to load report: ${report.reportFriendly}`);
    };

    if (!report || !report.uriPath) {
        return (
            <div className="text-center my-5">
                <p>This report doesn't have a valid URL</p>
            </div>
        );
    }

    return (
        <div className="report-viewer-container">
            <div className="card rounded-4 border overflow-hidden">
            <div
                className="card-body p-0 position-relative"
                style={{
                height: navbarVisible ? 'calc(100vh - 140px)' : 'calc(100vh - 80px)',
                minHeight: '600px',
                lineHeight: 0 // prevent inline baseline gap
                }}
            >
                {loading && (
                <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75"
                    style={{ zIndex: 2 }}
                >
                    <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                )}

                {error && (
                <div className="alert alert-danger m-3 position-relative" role="alert" style={{ zIndex: 3 }}>
                    {error}
                </div>
                )}

                <iframe
                src={reportUrl}
                title={report.reportFriendly}
                className="border-0 d-block"
                style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    transition: 'height 0.3s ease',
                    zIndex: 1,
                    padding: '12px',
                }}
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                allow="fullscreen"
                ></iframe>
            </div>
            </div>
        </div>
    );
};

export default ReportViewer;